import { render, staticRenderFns } from "./typeActivities.vue?vue&type=template&id=7dc0f765&scoped=true&"
import script from "./typeActivities.vue?vue&type=script&lang=js&"
export * from "./typeActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc0f765",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dc0f765')) {
      api.createRecord('7dc0f765', component.options)
    } else {
      api.reload('7dc0f765', component.options)
    }
    module.hot.accept("./typeActivities.vue?vue&type=template&id=7dc0f765&scoped=true&", function () {
      api.rerender('7dc0f765', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/activities/components/typeActivities.vue"
export default component.exports